import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Card } from '../../../interfaces/payment';
import BRAND_ICONS from '../assets/icons';

@Component({
  selector: 'ng-tickets-card-item',
  styleUrls: ['./card-item.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <div class="item-card" [class.editable]="selectable">

      <div class="item-card-img">
        <img [src]="getBrandIcon(card.brand)" alt="Brand Icon">
      </div>

      <div class="item-card-info" (click)="selectable && select.emit(card)">
        <div class="card-title">{{ card.holder_name }}</div>
        <div class="card-description">**** **** **** {{ card.last_four_digits }}</div>
      </div>

      <div class="item-card-remove" *ngIf="removable">
        <span class="fa fa-remove" (click)="remove.emit(this.card.id);"></span>
      </div>

      <div class="radio-container" (click)="select.emit(card)" *ngIf="selectable">
        <input
            class="radio-type-ticket"
            id="radio_{{card.id}}"
            name="typeTicket"
            type="radio"
            [value]="card"
            [checked]="isChecked"/>

        <label for="radio_{{card.id}}">
          <span class="fa fa-check"></span>
        </label>
      </div>
    </div>
  `
})
export class CardItemComponent {

  @Input() card: Card;
  @Input() selectable = true;
  @Input() removable = true;
  @Input() isChecked: boolean;
  @Output() remove = new EventEmitter();
  @Output() select = new EventEmitter();

  getBrandIcon(brand) {
    return BRAND_ICONS[brand] ? BRAND_ICONS[brand] : BRAND_ICONS.placeholder;
  }
}
